import script from "./CurveCompare.vue?vue&type=script&setup=true&lang=js"
export * from "./CurveCompare.vue?vue&type=script&setup=true&lang=js"

import "./CurveCompare.vue?vue&type=style&index=0&id=0196f39e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0196f39e"]])

export default __exports__